import React, { Component } from 'react';

class Invalidtokenpage extends Component {
    render() {
        return (
            <div>
                <div class="container text-center">
                    <div class="header-title text-center mt-5 mb-2">
                        <h1>ERROR!</h1>
                    </div>
                    <div className="row">
                        <div className="col-6 offset-3">
                            <div className="alert alert-danger text-center my-4">
                                You have provided an invalid token. Please contact administrator.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Invalidtokenpage;
